import React, {useContext, useState} from 'react'
import {Form, Select} from "antd";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import AccountSettingsRenewProductCardPayment from "./AccountSettingsRenewProductCardPayment";
import AccountSettingsRenewProductActivationKey from "./AccountSettingsRenewProductActivationKey";
import {UserContext} from "../common/UserContext";

const AccountSettingsRenewProduct = props => {
    const {data, checkFormStatus, handleSubmitForm} = props;
    const {user} = useContext(UserContext);
    const SELECT_OPTIONS = {
        ACTIVATION_KEY: 'activationKey',
        CREDIT_CARD: 'creditCard'
    }
    const [selectedOption, setSelectedOption] = useState(null);

    const handleSelectChange = (value) => {
        setSelectedOption(value);
    };

    return (
        <>
            <h3>Add or renew a product</h3>
            <p>Have an activation code or wish to purchase another <em>Cambridge HOTmaths</em> product?</p>
            <Form
                layout="vertical"
            >
                <Form.Item
                    label="Do you want to use an activation key or buy a new product?"
                    name="activationType"
                    rules={[{ required: true, message: 'Please select a purchase type' }]}
                    validateTrigger="onBlur"
                >
                    <Select onChange={handleSelectChange}>
                        <Select.Option value="activationKey">I have an activation key</Select.Option>
                        {!user.adminUser && data?.cardProducts.length > 0 && (
                            <Select.Option value="creditCard">I want to buy a new product</Select.Option>
                        )}
                    </Select>
                </Form.Item>
            </Form>
                {selectedOption === SELECT_OPTIONS.ACTIVATION_KEY && (
                    <AccountSettingsRenewProductActivationKey data={data} checkFormStatus={checkFormStatus} handleSubmitForm={handleSubmitForm} />
                )}
                {selectedOption === SELECT_OPTIONS.CREDIT_CARD && !user.adminUser && data?.cardProducts.length > 0 && (
                    <GoogleReCaptchaProvider reCaptchaKey="6LeEQ8sZAAAAAGi7WIDI40-BGQ2kv-E86xYtvMje">
                        <AccountSettingsRenewProductCardPayment checkFormStatus={checkFormStatus} data={data} handleSubmitForm={handleSubmitForm} />
                    </GoogleReCaptchaProvider>
                )}
        </>
    )
}

export default AccountSettingsRenewProduct;